// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.psform-submit {
  background-color: var(--primary);
  color: white;
  border-radius: 5px;
  border: solid 1px var(--primary);
  padding: 10px 10px;
  font-weight: bold;
  text-align: center;
}

.psform-submit:disabled {
  background-color: #96b2fa;
  color: white;
  border-radius: 5px;
  border: solid 1px #96b2fa;
  padding: 10px 10px;
  font-weight: bold;
  text-align: center;
}

.psform-submit-box{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: -webkit-fill-available;
  margin-top: 30px;
}

.psform-input-box{
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: -webkit-fill-available;
}

.psform-input-row{
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: -webkit-fill-available;
  align-items: center;
}

.psform-input-label{
  
}

.psform-input-text{
  border-radius: 5px;
  border: solid 1px var(--border);
  padding: 10px 10px;
  width: 50%;
}

.psform-input-text-multi{
  border-radius: 5px;
  border: solid 1px var(--border);
  padding: 10px 10px;
  width: 20%;
}

.psform{
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: -webkit-fill-available;
  padding: 20px 20px 0px 20px;
}

.psform-box-flex{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 10px;
  width: -webkit-fill-available;
}

.psform-ticker-box{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  width: -webkit-fill-available;
}

.ticker-img{
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.select-ticker-flex{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: -webkit-fill-available;
}

.select-ticker-search{
  width: 100%;
}

.ticker-results{
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 0px;
}

.select-ticker-product{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 10px 10px;
  cursor: pointer;
  gap: 10px;
  width: 300px;
}

.ticker-desc{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
}

.delete-ticker-button{
  font-size: 10px;
  color: var(--primary);
}

.psform-ticker-selected-box{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: -webkit-fill-available;
  background-color: var(--bg-card);
  padding: 15px;
  border-radius: 5px;
}

.button-add-new{
  background-color: var(--bg-card);
  color: var(--text-primary);
  border-radius: 5px;
  border: solid 1px var(--primary);
  padding: 5px 10px;
  text-align: center;
  cursor: pointer;
  width: max-content;
  font-size: 12px;
}

.psform-description-box{
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: -webkit-fill-available;
}

.psform-input-text-full{
  border-radius: 5px;
  border: solid 1px var(--border);
  padding: 10px 10px;
  width: -webkit-fill-available;
}

.description-box-wrapper{
  background-color: var(--bg-card);
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 10px;
  padding: 10px;
  width: -webkit-fill-available;
}

.psform-input-label-text-small{
  font-size: 12px;
}

.psform-input-box-flex{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex start;
  gap: 10px;
  width: -webkit-fill-available;  
}

.paradox_playlists_box{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 10px 10px;
  gap: 20px;
  width: 100%;
  position: relative;
  z-index: 0;
}

.paradox_playlists_box{
  display: grid;
  margin-top: 2rem;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 20px;
  row-gap: 50px;
  width: 100%;

}

.paradox_playlists_item_box{
  display: flex;
  flex-direction: column;
  padding: 20px 10px;
  gap: 10px;
  width: 300px;
  border-radius: 10px;
  position: relative;
}

.paradox_playlists_item_title{
  padding-left: 10px;
  font-weight: bold;
  margin: 0px;
}

.paradox_sp_item_delete_button,
.paradox_playlists_item_delete_button{
  position: absolute;
  top: 0px;
  right: 15px;
  font-weight: bold;
  width: 22px;
  height: 22px;
  color: var(--text-primary);
  border: none;
  border-radius: 50%;
  border: 2px solid;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.paradox_playlists_search{
  width: 100%;
  position: relative;
  z-index: 1;
}

.paradox_playlists_search_results{
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 0px;
  position: relative;
  z-index: 2;
}

.paradox_playlists_search_results_item{
  flex-direction: column;
  background-color: var(--bg-card);
  border: 1px solid;
  padding-left: 10px;
}

.ticker-img{
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.paradox_stocks_search_box,
.paradox_etfs_search_box {
  width: 60%
}
.paradox_stocks_search_input_box,
.paradox_etfs_search_input_box{
  border-radius: 5px;
  border: solid 1px var(--border);
  padding: 10px 10px;
  width: 70%;
}
.paradox_stocks_details_box,
.paradox_etfs_details_box {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 5px 5px;
  width: 40%;
  position: relative;
}
.paradox_stocks_selected_item,
.paradox_etfs_selected_item {
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/pages/paradox/builder/paradoxBuilder.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;AAEA;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;EAChC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;EAChB,aAAa;EACb,WAAW;;AAEb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE;AACF;AACA;;EAEE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".psform-submit {\n  background-color: var(--primary);\n  color: white;\n  border-radius: 5px;\n  border: solid 1px var(--primary);\n  padding: 10px 10px;\n  font-weight: bold;\n  text-align: center;\n}\n\n.psform-submit:disabled {\n  background-color: #96b2fa;\n  color: white;\n  border-radius: 5px;\n  border: solid 1px #96b2fa;\n  padding: 10px 10px;\n  font-weight: bold;\n  text-align: center;\n}\n\n.psform-submit-box{\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  width: -webkit-fill-available;\n  margin-top: 30px;\n}\n\n.psform-input-box{\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: -webkit-fill-available;\n}\n\n.psform-input-row{\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  width: -webkit-fill-available;\n  align-items: center;\n}\n\n.psform-input-label{\n  \n}\n\n.psform-input-text{\n  border-radius: 5px;\n  border: solid 1px var(--border);\n  padding: 10px 10px;\n  width: 50%;\n}\n\n.psform-input-text-multi{\n  border-radius: 5px;\n  border: solid 1px var(--border);\n  padding: 10px 10px;\n  width: 20%;\n}\n\n.psform{\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: -webkit-fill-available;\n  padding: 20px 20px 0px 20px;\n}\n\n.psform-box-flex{\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  gap: 10px;\n  width: -webkit-fill-available;\n}\n\n.psform-ticker-box{\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10px;\n  width: -webkit-fill-available;\n}\n\n.ticker-img{\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n}\n\n.select-ticker-flex{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: -webkit-fill-available;\n}\n\n.select-ticker-search{\n  width: 100%;\n}\n\n.ticker-results{\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 10px 0px;\n}\n\n.select-ticker-product{\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  padding: 10px 10px;\n  cursor: pointer;\n  gap: 10px;\n  width: 300px;\n}\n\n.ticker-desc{\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10px;\n}\n\n.delete-ticker-button{\n  font-size: 10px;\n  color: var(--primary);\n}\n\n.psform-ticker-selected-box{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: -webkit-fill-available;\n  background-color: var(--bg-card);\n  padding: 15px;\n  border-radius: 5px;\n}\n\n.button-add-new{\n  background-color: var(--bg-card);\n  color: var(--text-primary);\n  border-radius: 5px;\n  border: solid 1px var(--primary);\n  padding: 5px 10px;\n  text-align: center;\n  cursor: pointer;\n  width: max-content;\n  font-size: 12px;\n}\n\n.psform-description-box{\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  width: -webkit-fill-available;\n}\n\n.psform-input-text-full{\n  border-radius: 5px;\n  border: solid 1px var(--border);\n  padding: 10px 10px;\n  width: -webkit-fill-available;\n}\n\n.description-box-wrapper{\n  background-color: var(--bg-card);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  border-radius: 10px;\n  padding: 10px;\n  width: -webkit-fill-available;\n}\n\n.psform-input-label-text-small{\n  font-size: 12px;\n}\n\n.psform-input-box-flex{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex start;\n  gap: 10px;\n  width: -webkit-fill-available;  \n}\n\n.paradox_playlists_box{\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: flex-start;\n  padding: 10px 10px;\n  gap: 20px;\n  width: 100%;\n  position: relative;\n  z-index: 0;\n}\n\n.paradox_playlists_box{\n  display: grid;\n  margin-top: 2rem;\n  grid-template-columns: repeat(4, 1fr);\n  column-gap: 20px;\n  row-gap: 50px;\n  width: 100%;\n\n}\n\n.paradox_playlists_item_box{\n  display: flex;\n  flex-direction: column;\n  padding: 20px 10px;\n  gap: 10px;\n  width: 300px;\n  border-radius: 10px;\n  position: relative;\n}\n\n.paradox_playlists_item_title{\n  padding-left: 10px;\n  font-weight: bold;\n  margin: 0px;\n}\n\n.paradox_sp_item_delete_button,\n.paradox_playlists_item_delete_button{\n  position: absolute;\n  top: 0px;\n  right: 15px;\n  font-weight: bold;\n  width: 22px;\n  height: 22px;\n  color: var(--text-primary);\n  border: none;\n  border-radius: 50%;\n  border: 2px solid;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.paradox_playlists_search{\n  width: 100%;\n  position: relative;\n  z-index: 1;\n}\n\n.paradox_playlists_search_results{\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 10px 0px;\n  position: relative;\n  z-index: 2;\n}\n\n.paradox_playlists_search_results_item{\n  flex-direction: column;\n  background-color: var(--bg-card);\n  border: 1px solid;\n  padding-left: 10px;\n}\n\n.ticker-img{\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n}\n\n.paradox_stocks_search_box,\n.paradox_etfs_search_box {\n  width: 60%\n}\n.paradox_stocks_search_input_box,\n.paradox_etfs_search_input_box{\n  border-radius: 5px;\n  border: solid 1px var(--border);\n  padding: 10px 10px;\n  width: 70%;\n}\n.paradox_stocks_details_box,\n.paradox_etfs_details_box {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 5px 5px;\n  width: 40%;\n  position: relative;\n}\n.paradox_stocks_selected_item,\n.paradox_etfs_selected_item {\n  display: flex;\n  flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
